import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory as createHistory } from "history";
import { Provider } from "react-redux";
import { Switch, Route, Redirect } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import LoadableVisibility from "react-loadable-visibility/react-loadable";

import createStore from "store/createStore";
import AuthenticatedRoute from "containers/AuthenticatedRoute";

import { initAuth } from "containers/Auth";

import { ROUTES } from 'constants/constants';

// Global Styles
import "normalize.css/normalize.css";
import "react-table/react-table.css";
import "styles/react-table.scss";
import "styles/index.scss";

// Sync Components

// Async Components
const AsyncAppKardiaSupportContainer = LoadableVisibility({
  loader: () => import("routes/App"),
  loading: () => null,
  render(loaded, props) {
    const Component = loaded.default(props, store);
    return <Component {...props} />;
  }
});

const AsyncAppShopifySupportContainer = LoadableVisibility({
  loader: () => import("routes/App"),
  loading: () => null,
  render(loaded, props) {
    const Component = loaded.default(props, store);
    return <Component {...props} />;
  }
});

const AsyncLoginContainer = LoadableVisibility({
  loader: () => import("routes/Login"),
  loading: () => null,
  render(loaded, props) {
    const Component = loaded.default(props, store);
    return <Component {...props} />;
  }
});

const AsyncDeviceLockContainer = LoadableVisibility({
  loader: () => import("routes/DeviceSupport"),
  loading: () => null,
  render(loaded, props) {
    const Component = loaded.default(props, store);
    return <Component {...props} />;
  }
});

const AsyncInnerCircleContainer = LoadableVisibility({
  loader: () => import("routes/App"),
  loading: () => null,
  render(loaded, props) {
    const Component = loaded.default(props, store);
    return <Component {...props} />;
  }
});

// Store and Router History
const history = createHistory();
const initialState = {};
const store = createStore(initialState, history);

store.dispatch(initAuth());

// React Hook
ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      {/* Routes */}
      <Switch>
        <Route exact path="/login" component={AsyncLoginContainer} />
        <AuthenticatedRoute exact path={ROUTES.ROOT} component={AsyncAppKardiaSupportContainer} />
        <AuthenticatedRoute exact path={ROUTES.SHOPIFY} component={AsyncAppShopifySupportContainer} />
        <AuthenticatedRoute exact path={ROUTES.DEVICE_LOCK} component={AsyncDeviceLockContainer} />
        <AuthenticatedRoute exact path={ROUTES.INNER_CIRCLE} component={AsyncInnerCircleContainer} />
        <Redirect from="/*" to="/login" />
      </Switch>
    </ConnectedRouter>
  </Provider>,
  // Mount node
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.jsx